import { loading } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import GedSubjectRepository from '@/shared/http/repositories/business/gedsubject'
import gedSubjectModel from '@/shared/models/business/gedsubjectmodel'
import addSubjectForm from './addsubject-form'

export default {
  name: 'AddSubject',
  mixins: [ActionsForm],
  data () {
    return {
      data: gedSubjectModel,
      form: addSubjectForm
    }
  },
  created () {
    this.onClear()
  },
  methods: {
    onLoad () {
      loading.push()
      GedSubjectRepository.GetAll()
        .then(response => {
          this.onResultGrid(response)
        })
        .catch(err => this.onException(err))
    },
    onCreate () {
      loading.push()
      GedSubjectRepository.Create(this.data)
        .then(response => {
          this.onResult(response)
        })
        .catch(err => this.onException(err))
    },
    onUpdate () {
      loading.push()
      this.data.status = parseInt(this.data.status)
      GedSubjectRepository.Update(this.data)
        .then(response => {
          this.onResult(response)
        })
        .catch(err => this.onException(err))
    },
    onDelete (obj) {
      loading.push()
      GedSubjectRepository.Delete(obj.id)
        .then(response => {
          this.onResult(response)
        })
        .catch(err => this.onException(err))
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/documents/components/subject/addsubject.js